import {
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_CONFIRMATION,
  CHANGE_PASSWORD_RESET_EMAIL,
  CHANGE_SIGN_IN_EMAIL,
  CHANGE_SIGN_IN_PASSWORD,
  FAILURE_AUTHENTICATION,
  FAILURE_CREATE_USER,
  FAILURE_DELETE_USER,
  FAILURE_FETCH_USERS,
  FAILURE_INITIALIZE_CONFIRMATION,
  FAILURE_INITIALIZE_RECONFIRMATION,
  FAILURE_REGISTER,
  FAILURE_RESET_PASSWORD,
  FAILURE_SIGN_IN,
  FAILURE_SIGN_OUT,
  FAILURE_UPDATE_PASSWORD,
  FAILURE_UPDATE_USER,
  FAILURE_VERIFY_SESSION,
  REQUEST_CREATE_USER,
  REQUEST_DELETE_USER,
  REQUEST_FETCH_USERS,
  REQUEST_INITIALIZE_CONFIRMATION,
  REQUEST_INITIALIZE_RECONFIRMATION,
  REQUEST_REGISTER,
  REQUEST_RESET_PASSWORD,
  REQUEST_SIGN_IN,
  REQUEST_SIGN_OUT,
  REQUEST_UPDATE_PASSWORD,
  REQUEST_UPDATE_USER,
  REQUEST_VERIFY_SESSION,
  RESET_USERS_STATE,
  SUCCESS_AUTHENTICATION,
  SUCCESS_CREATE_USER,
  SUCCESS_DELETE_USER,
  SUCCESS_FETCH_USERS,
  SUCCESS_INITIALIZE_CONFIRMATION,
  SUCCESS_INITIALIZE_RECONFIRMATION,
  SUCCESS_REGISTER,
  SUCCESS_RESET_PASSWORD,
  SUCCESS_SIGN_IN,
  SUCCESS_SIGN_OUT,
  SUCCESS_UPDATE_PASSWORD,
  SUCCESS_UPDATE_USER,
  TOGGLE_PRIVACY_POLICY,
  TOGGLE_SESSION_EXTENDED,
} from 'actions/actionTypes';
import { BackendUserActionTypes, BackendUserState, UserTypes } from 'types/backend/user';
import calculatePageList from 'utils/calculatePageList';

export const initialState: BackendUserState = {
  isInitialized: false,
  isInitializedConfirmation: false,
  isLoading: false,
  isAuthenticated: false,
  name: '',
  companyId: null, // Adminでログインした場合
  companyName: '', // Adminでログインした場合
  signInEmail: '',
  signInPassword: '',
  isSessionExtended: false,
  passwordResetEmail: '',
  email: '',
  password: '',
  passwordConfirmation: '',
  isAgreedPrivacyPolicy: false, // AdminのConfirmation時
  passwordErrorMessages: [],
  passwordConfirmationErrorMessages: [],
  privacyPolicyErrorMessages: [], // AdminのConfirmation時
  users: [],
  userSize: 0,
  currentPage: 1,
  currentPageUserList: '',
};

const backendUserReducer = (
  state = initialState,
  action: BackendUserActionTypes,
): BackendUserState => {
  switch (action.type) {
    case RESET_USERS_STATE: {
      return {
        ...state,
        users: initialState.users,
        userSize: initialState.userSize,
        currentPage: initialState.currentPage,
        currentPageUserList: initialState.currentPageUserList,
      };
    }
    case REQUEST_VERIFY_SESSION: {
      return state;
    }
    case SUCCESS_AUTHENTICATION: {
      const { payload } = action;
      const { name, companyId, companyName } = payload;
      return {
        ...state,
        isInitialized: true,
        isAuthenticated: true,
        name,
        companyId: companyId || initialState.companyId,
        companyName: companyName || initialState.companyName,
      };
    }
    case FAILURE_AUTHENTICATION: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case FAILURE_VERIFY_SESSION: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case CHANGE_SIGN_IN_EMAIL: {
      const { signInEmail } = action;
      return {
        ...state,
        signInEmail,
      };
    }
    case CHANGE_SIGN_IN_PASSWORD: {
      const { signInPassword } = action;
      return {
        ...state,
        signInPassword,
      };
    }
    case TOGGLE_SESSION_EXTENDED: {
      const { flag } = action;
      return {
        ...state,
        isSessionExtended: flag,
      };
    }
    case REQUEST_SIGN_IN: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_SIGN_IN: {
      const { payload } = action;
      const { name, companyId, companyName } = payload;

      return {
        ...state,
        isLoading: initialState.isLoading,
        isAuthenticated: true,
        name,
        companyId: companyId || initialState.companyId,
        companyName: companyName || initialState.companyName,
        signInEmail: initialState.signInEmail,
        signInPassword: initialState.signInPassword,
        isSessionExtended: initialState.isSessionExtended,
      };
    }
    case FAILURE_SIGN_IN: {
      return {
        ...state,
        isLoading: initialState.isLoading,
      };
    }
    case REQUEST_SIGN_OUT: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_SIGN_OUT: {
      return {
        ...state,
        isLoading: initialState.isLoading,
        isAuthenticated: initialState.isAuthenticated,
        name: initialState.name,
        companyId: initialState.companyId,
        companyName: initialState.companyName,
      };
    }
    case FAILURE_SIGN_OUT: {
      return {
        ...state,
        isLoading: initialState.isLoading,
      };
    }
    case CHANGE_PASSWORD_RESET_EMAIL: {
      const { passwordResetEmail } = action;
      return {
        ...state,
        passwordResetEmail,
      };
    }
    case REQUEST_RESET_PASSWORD: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_RESET_PASSWORD: {
      return {
        ...state,
        isLoading: initialState.isLoading,
        passwordResetEmail: initialState.passwordResetEmail,
      };
    }
    case FAILURE_RESET_PASSWORD: {
      return {
        ...state,
        isLoading: initialState.isLoading,
      };
    }
    case CHANGE_PASSWORD: {
      const { password } = action;
      return {
        ...state,
        password,
      };
    }
    case CHANGE_PASSWORD_CONFIRMATION: {
      const { passwordConfirmation } = action;
      return {
        ...state,
        passwordConfirmation,
      };
    }
    case REQUEST_UPDATE_PASSWORD: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_UPDATE_PASSWORD: {
      const { payload } = action;
      const { name, companyId, companyName } = payload;

      return {
        ...state,
        isLoading: initialState.isLoading,
        isAuthenticated: true,
        name,
        companyId: companyId || initialState.companyId,
        companyName: companyName || initialState.companyName,
        password: initialState.password,
        passwordConfirmation: initialState.passwordConfirmation,
        passwordErrorMessages: initialState.passwordErrorMessages,
        passwordConfirmationErrorMessages: initialState.passwordConfirmationErrorMessages,
      };
    }
    case FAILURE_UPDATE_PASSWORD: {
      const { error } = action;

      return {
        ...state,
        isLoading: initialState.isLoading,
        passwordErrorMessages: error.password ? error.password : [],
        passwordConfirmationErrorMessages: error.password_confirmation
          ? error.password_confirmation
          : [],
      };
    }
    case TOGGLE_PRIVACY_POLICY: {
      const { flag } = action;
      return {
        ...state,
        isAgreedPrivacyPolicy: flag,
      };
    }
    case REQUEST_INITIALIZE_CONFIRMATION: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_INITIALIZE_CONFIRMATION: {
      const { payload } = action;
      return {
        ...state,
        isInitializedConfirmation: true,
        isLoading: initialState.isLoading,
        email: payload.email,
      };
    }
    case FAILURE_INITIALIZE_CONFIRMATION: {
      return {
        ...state,
        isInitializedConfirmation: true,
        isLoading: initialState.isLoading,
      };
    }
    case REQUEST_INITIALIZE_RECONFIRMATION: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_INITIALIZE_RECONFIRMATION: {
      const { payload } = action;
      return {
        ...state,
        isInitializedConfirmation: true,
        isLoading: initialState.isLoading,
        signInEmail: payload.email,
      };
    }
    case FAILURE_INITIALIZE_RECONFIRMATION: {
      return {
        ...state,
        isInitializedConfirmation: true,
        isLoading: initialState.isLoading,
      };
    }
    case REQUEST_REGISTER: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS_REGISTER: {
      const { payload } = action;
      const { name, companyId, companyName } = payload;

      return {
        ...state,
        isLoading: initialState.isLoading,
        isAuthenticated: true,
        name,
        companyId: companyId || initialState.companyId,
        companyName: companyName || initialState.companyName,
        password: initialState.password,
        passwordConfirmation: initialState.passwordConfirmation,
        isAgreedPrivacyPolicy: initialState.isAgreedPrivacyPolicy,
        passwordErrorMessages: initialState.passwordErrorMessages,
        passwordConfirmationErrorMessages: initialState.passwordConfirmationErrorMessages,
        privacyPolicyErrorMessages: initialState.privacyPolicyErrorMessages,
      };
    }
    case FAILURE_REGISTER: {
      const { error } = action;

      return {
        ...state,
        isLoading: initialState.isLoading,
        passwordErrorMessages: error.password ? error.password : [],
        passwordConfirmationErrorMessages: error.password_confirmation
          ? error.password_confirmation
          : [],
        privacyPolicyErrorMessages: error.privacy_policy_agreed_at
          ? error.privacy_policy_agreed_at
          : [],
      };
    }
    case REQUEST_FETCH_USERS: {
      return {
        ...state,
      };
    }
    case SUCCESS_FETCH_USERS: {
      const { payload, size, pageNumber } = action;
      const calculatedPageList = calculatePageList(payload, pageNumber);
      return {
        ...state,
        users: payload,
        userSize: size,
        currentPage: pageNumber,
        currentPageUserList: calculatedPageList,
      };
    }
    case FAILURE_FETCH_USERS: {
      return {
        ...state,
      };
    }
    case REQUEST_CREATE_USER: {
      return {
        ...state,
      };
    }
    case SUCCESS_CREATE_USER: {
      const { payload } = action;

      const updatedUsers = state.users.length < 20 ? [...state.users, payload] : [...state.users];
      const calculatedPageList = calculatePageList(updatedUsers, state.currentPage);

      return {
        ...state,
        users: updatedUsers,
        userSize: state.userSize + 1,
        currentPageUserList: calculatedPageList,
      };
    }
    case FAILURE_CREATE_USER: {
      return {
        ...state,
      };
    }
    case REQUEST_UPDATE_USER: {
      return {
        ...state,
      };
    }
    case SUCCESS_UPDATE_USER: {
      const { payload } = action;

      const updatedUsers = state.users.map((user: UserTypes) => {
        if (user.id === payload.id) return payload;
        return user;
      });

      return {
        ...state,
        users: updatedUsers,
      };
    }
    case FAILURE_UPDATE_USER: {
      return {
        ...state,
      };
    }
    case REQUEST_DELETE_USER: {
      return {
        ...state,
      };
    }
    case SUCCESS_DELETE_USER: {
      const { id } = action;

      const updatedUsers = state.users.filter((user: UserTypes) => {
        return user.id !== id;
      });

      const calculatedPageList = calculatePageList(updatedUsers, state.currentPage);

      return {
        ...state,
        users: updatedUsers,
        userSize: state.userSize - 1,
        currentPageUserList: calculatedPageList,
      };
    }
    case FAILURE_DELETE_USER: {
      return {
        ...state,
      };
    }
    default: {
      return state;
    }
  }
};

export default backendUserReducer;
